import { Button } from '~/components/button'
import type { IProductHeaderButtonProps } from '~/index'

export function ProductHeaderFirstButton({
  onPress,
  testID,
  symbol,
  ...props
}: IProductHeaderButtonProps) {
  return (
    <Button.Root
      {...props}
      variant="neutral-secondary"
      size="ml"
      testID={testID}
    >
      <Button.Icon symbol={symbol} />
    </Button.Root>
  )
}
